import { Main } from '@components/Main';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { VerticalGrid } from '@components/VerticalGrid';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { HomeCaixa } from './Caixa';
import { HomeContrato } from './Contrato';
import { HomePagamento } from './Pagamento';
import { Content } from '@components/Content';

export type HomeProps = {

}

export function Home (props: HomeProps) {
    const cls = useStyles();

    return (
        <Main>
            <Content>
                <VerticalGrid>
                    <GridItem>
                        <HorizontalGrid spacing={2}>
                            <GridItem xs={6} className={cls.sectionContainer}>
                                <HomeCaixa />
                            </GridItem>
                            
                            <GridItem xs={6} className={cls.sectionContainer}>
                                <HomePagamento />
                            </GridItem>
                        </HorizontalGrid>
                    </GridItem>

                    <GridItem className={cls.sectionContainer}>
                        <HomeContrato />
                    </GridItem>
                </VerticalGrid>
            </Content>
        </Main>
    )
}

const useStyles = makeStyles(theme => ({
    sectionContainer: {
        marginTop: 20,
        minWidth: 470
    }
}));